import { Json } from "./database.types";

export interface Account {
  id: string;
  name: string;
  description: string;
  metadata: Json | null;
  created: string;
  modified: string;
  deleted: string | null;
  enabled: boolean;
  helper_names: string | null;
  email_to_users: boolean;
  attachments_to_users: boolean;
  email_bcc_addresses: string | null;
  spoke_tenant_id: string | null;
  spoke_client_id: string | null;
  spoke_client_secret: string | null;
  sample_rate_pct: number | null;
  user_filter: string | null;
  protocol_list: string | null;
  email_flags: EmailFlags | null;
  company_tone_and_language: string | null;
  email_bcc_groups: AnalysisGroups | null;
}

export interface AnalysisGroup {
  name: string;
  emailAddress: string;
  lenses: string[];
  users: string[];
}

export interface AnalysisGroups {
  groups: AnalysisGroup[];
}

export interface EmailFeatureRecipients {
  user: boolean;
  bcc: boolean;
}

export interface EmailFlags {
  topics: string[];
  scorecard: string[];
  riskAnalysis: string[];
  extendedSummary: string[];
  openConversationButton: string[];
}

export interface EmailFlagsDisplay {
  topics: EmailFeatureRecipients;
  scorecard: EmailFeatureRecipients;
  riskAnalysis: EmailFeatureRecipients;
  extendedSummary: EmailFeatureRecipients;
  openConversationButton: EmailFeatureRecipients;
}

export const emailFlagsToDisplay = (emailFlags: EmailFlags | null): EmailFlagsDisplay => {
  const defaultFlags: EmailFlagsDisplay = {
    topics: { user: false, bcc: false },
    scorecard: { user: false, bcc: false },
    riskAnalysis: { user: false, bcc: false },
    extendedSummary: { user: false, bcc: false },
    openConversationButton: { user: false, bcc: false }
  };

  if (!emailFlags) {
    return defaultFlags;
  }

  return {
    topics: {
      user: emailFlags.topics.includes("user"),
      bcc: emailFlags.topics.includes("bcc")
    },
    scorecard: {
      user: emailFlags.scorecard.includes("user"),
      bcc: emailFlags.scorecard.includes("bcc")
    },
    riskAnalysis: {
      user: emailFlags.riskAnalysis.includes("user"),
      bcc: emailFlags.riskAnalysis.includes("bcc")
    },
    extendedSummary: {
      user: emailFlags.extendedSummary.includes("user"),
      bcc: emailFlags.extendedSummary.includes("bcc")
    },
    openConversationButton: {
      user: emailFlags.openConversationButton.includes("user"),
      bcc: emailFlags.openConversationButton.includes("bcc")
    }
  };
};

export const displayToEmailFlags = (display: EmailFlagsDisplay): EmailFlags => {
  const emailFlags: EmailFlags = {
    topics: [],
    scorecard: [],
    riskAnalysis: [],
    extendedSummary: [],
    openConversationButton: []
  };

  if (display.topics.user) {
    emailFlags.topics.push("user");
  }
  if (display.topics.bcc) {
    emailFlags.topics.push("bcc");
  }

  if (display.scorecard.user) {
    emailFlags.scorecard.push("user");
  }
  if (display.scorecard.bcc) {
    emailFlags.scorecard.push("bcc");
  }

  if (display.riskAnalysis.user) {
    emailFlags.riskAnalysis.push("user");
  }
  if (display.riskAnalysis.bcc) {
    emailFlags.riskAnalysis.push("bcc");
  }

  if (display.extendedSummary.user) {
    emailFlags.extendedSummary.push("user");
  }
  if (display.extendedSummary.bcc) {
    emailFlags.extendedSummary.push("bcc");
  }

  if (display.openConversationButton.user) {
    emailFlags.openConversationButton.push("user");
  }
  if (display.openConversationButton.bcc) {
    emailFlags.openConversationButton.push("bcc");
  }

  return emailFlags;
};

export const PROTOCOLS = [
  "automotive",
  "b2b-saas",
  "big-box-retail",
  "crisis-and-community-services",
  "engineering",
  "financial-services",
  "for-profit-education",
  "freight-and-logistics",
  "healthcare-services",
  "hospitality",
  "insurance",
  "legal-services",
  "manufacturing",
  "moving-and-storage",
  "property-management",
  "real-estate-brokerage"
];
